import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { Body } from 'atoms/Typography/Typography';
import styles from './styles.module.css';

export const FilterItem: FC<
  PropsWithChildren & {
    label?: string;
    value?: string;
    className?: string;
    isActive?: boolean;
    onClick?: () => void;
  }
> = ({ children, label, value, onClick, className, isActive }) => {
  return (
    <div
      className={clsx(
        styles.filter,
        isActive && styles.active,
        label && label && styles.textContainer,
        className,
      )}
      onClick={onClick}
    >
      {children || (
        <>
          <Body tag="span" type="md">
            {label}
          </Body>
          <Body tag="span" type="md" weight="bold" className={styles.value}>
            {value}
          </Body>
        </>
      )}
    </div>
  );
};
